import './index.css'

const CategoryListComponent = ({ value=[], config={}, events={} }) => {
    const handleEdit = (item) => {
        if (events.handleEdit)
            events.handleEdit(item)
    }

    const handleDelete = (item) => {
        if (events.handleDelete)
            events.handleDelete(item)
    }

    return (
        <div className="c-CategoryList">
            <div className="categoryList-rows">
                {value.map((item) => (
                    <div className="categoryList-row" key={`categoryList-row-${item.id}`}>
                        <div className="categoryList-identity" onClick={() => handleEdit(item)}>
                            <div className="categoryList-name">{item.name}</div>
                            <div className="categoryList-slug">{item.slug}</div>
                        </div>

                        <div className="categoryList-actions">
                            <button type="button" className="categoryList-actionButton" onClick={() => handleEdit(item)}>
                                Edit
                            </button>

                            <button type="button" className="categoryList-actionButton categoryList-actionButton-danger" onClick={() => handleDelete(item)}>
                                Delete
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export { CategoryListComponent }
